<!-- Just an image -->
<nav class="navbar navbar-light bg-white">
  <a class="navbar-brand" rel="noopener noreferrer"  href="">
    <img src="./assets/img/franja.svg" width="60" height="30" alt="">
  </a>
  <!--<div class="container-fluid">
    <form class="d-flex">
      <div class="card-column" style="width: 58rem;border:0ch" >
      </div>
      <div class="card-column ms-3" >
        <button class="btn btn-outline-primary" (click)="cerrar();" type="submit">Cerrar Sesión</button>
      </div>
   </form>
  </div>-->
</nav>
